<template>
  <div class="product-screen">
    <div class="title font-sc-me">热门竞品</div>
    <div class="info">
      <div
        class="item ellipses "
        :class="sel_brand == item ? 'ac-item font-sc-me' : 'bg-f6'"
        v-for="(item, index) in hot_brand"
        :key="index"
        @click="selHotBrand(item)"
      >
        {{ item }}
        <div class="check-sign flex" v-if="sel_brand == item">
          <img src="../../../assets/check_sign.png" alt="" />
        </div>
      </div>
    </div>
    <div class="picker">
      <div class="picker-text font-sc-me">请选择</div>
      <van-picker
        ref="myPicker"
        class="picker-height"
        :default-index="default_index"
        :columns="columns"
        @change="onChange"
        @confirm="onConfirm"
      />
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, toRefs, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import Api from "../../../api/ProductApi";
export default {
  name: "ProductScreen",
  setup(props, proxy1) {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    let datas = reactive({
      hot_brand: [], // 热门竞品数据
      brand_list: {}, // 竞品品牌数据
      columns: [], // 多列数据
      sel_brand: "", // 选中的热门品牌
      default_index: 0, // 默认品牌下标
      brand_keys: [] // 品牌key值集合
    });

    // 获取数据
    const getScreenList = async () => {
      proxy.$toast.loading({
        message: "加载中..."
      });
      try {
        const { code, data } = await Api.competitorScreenList();
        proxy.$toast.clear();
        if (code == 0) {
          datas.hot_brand = data.hot_brand;
          datas.brand_list = data.brand_list;
          datas.columns = [
            { values: Object.keys(datas.brand_list) },
            { values: datas.brand_list[Object.keys(datas.brand_list)[0]] }
          ];
          datas.sel_brand = Object.keys(datas.brand_list)[0];
        }
      } catch (error) {
        proxy.$toast.clear();
        console.error(error);
      }
    };
    // 选中热门品牌
    const selHotBrand = val => {
      if (datas.sel_brand != val) {
        datas.sel_brand = val;
        datas.brand_keys = Object.keys(datas.brand_list);
        if (datas.brand_keys.indexOf(val) > -1) {
          proxy.$refs.myPicker.setIndexes([datas.brand_keys.indexOf(val)]);
          proxy.$refs.myPicker.setColumnValues(1, datas.brand_list[val]);
        }
      }
    };
    onMounted(() => {
      getScreenList();
    });
    /**
     * 在change 第一列的时候，动态更改第二列的数据
     * setColumnValues是vant自带的实例方法
     */
    const onChange = vals => {
      datas.sel_brand = vals[0];
      //第一个参数是列数，从0开始；第二个参数是第二列应该显示的数据
      proxy.$refs.myPicker.setColumnValues(1, datas.brand_list[vals[0]]);
    };
    // 确认跳转结果页
    let onConfirm = val => {
      proxy1.emit("close"); // 关闭父组件的弹框
      router.push({
        name: "List",
        query: {
          search_type: 3,
          keywords: val[0],
          oils_type: val[1]
        }
      });
    };
    return {
      onChange,
      ...toRefs(datas),
      selHotBrand,
      onConfirm
    };
  }
};
</script>
<style lang="sass" scoped>
@import "~@/styles/mixins/vw"
::v-deep(.van-picker__toolbar)
  justify-content: flex-end
::v-deep(.van-picker__cancel)
  display: none
::v-deep(.van-picker__confirm)
  position: absolute
  top: vw(-25)
  right: vw(30)
  height: vw(30)
  padding: 0
  color: #5E7BFF
::v-deep(.van-picker-column)
  font-size: vw(28)
::v-deep(.van-picker-column__item)
  line-height: vw(44)
::v-deep(.van-picker__columns)
  padding-bottom: vw(20)
.product-screen
  width: 100%
  height: vw(786)
  padding-bottom: vw(50)
  font-size: vw(28)
  color: #404040
  background: #FFFFFF
  .title
    padding: vw(40) 0 vw(20) vw(40)
    font-size: vw(32)
  .info
    display: flex
    padding: vw(0) vw(40) 0 vw(20)

    flex-wrap: wrap
    .item
      position: relative
      width: vw(154)
      height: vw(70)
      margin: vw(20) 0 0 vw(18)
      padding: 0 vw(10)
      line-height: vw(70)
      text-align: center
      .check-sign
        position: absolute
        right: vw(0)
        bottom: 0
        width: vw(32)
        height: vw(32)
    .bg-f6
      color: #404040
      background: #F6F6F6
    .ac-item
      color: #5E7BFF
      border: vw(1) solid #5E7BFF
      background: #EEF1FF
      box-shadow: 0 vw(12) vw(24) 0 rgba(94, 123, 255, 0.15)
  .picker
    padding: vw(40) 0 0 vw(00)
    .picker-text
      padding-left: vw(40)
      font-size: vw(32)
      color: #5E7BFF
</style>
